import { getAll, create, updateById, deleteById } from './changelogMethods';

export const supabaseChangelogInit = (supabase) => { 
  return {
    getAll: getAll.bind(this, supabase),
    create: create.bind(this, supabase),
    updateById: updateById.bind(this, supabase),
    deleteById: deleteById.bind(this, supabase),
  }
}

